module.exports = __webpack_public_path__ + "img/ic24UGender.58deab22.svg";